export const JOB_COUNT = "job_count"
export const JOB_COUNT_SUCCESSFUL = "job_count_successfull"
export const JOB_COUNT_FAILED = "job_count_failed"
export const JOB_SEARCH_COUNT = "job_search_count"